// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ck.ck-editor__editable span[data-ck-hidden]{display:none}", "",{"version":3,"sources":["webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/renderer.css"],"names":[],"mappings":"AAAA,6CAA6C,YAAY","sourcesContent":[".ck.ck-editor__editable span[data-ck-hidden]{display:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
